import { MediaMatcher } from '@angular/cdk/layout';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { Observable, Subscription } from 'rxjs';
import { IPeriodDate } from 'src/app/action-history-queue/interfaces/date-range.interface';
import { DistributionService } from 'src/app/distribution-queue/leads-management/services/distribution-service/distribution.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @Input() events: Observable<any>;
  @Input() companyEvents: Observable<any>;
  isToday: boolean;
  startDate: string;
  endDate: string;
  eventsSubscription: Subscription
  displayedColumns = [];
  displayedColumnsWithoutOnline = ['filas', 'leads', 'corretores_total'];
  dataSource = new MatTableDataSource([]);
  order = 'DESC';
  loading: boolean = true;
  maxResults: number = 5;
  page = 1;
  total: number = 0;
  columns = [];
  companyId: string = "";

  constructor(private distributionService: DistributionService, public media: MediaMatcher) { }

  ngOnInit(): void {
    this.initColumn();

    this.companyEvents.subscribe(res => {
      this.companyId = res;
      this.getData();
    });

    this.eventsSubscription = this.events.subscribe(
      (res: IPeriodDate) => {
        this.isToday = res.label == 'Hoje';
        
        if (!this.isToday) {
          this.displayedColumns = ['filas', 'leads', 'corretores_total'];
          this.columns = [
            { columnDef: 'filas', header: 'Filas', label: 'name' },
            { columnDef: 'leads', header: 'Leads recebidos', label: 'received_lead_amount', sort: true },
            { columnDef: 'corretores_total', header: 'Total de Corretores', label: 'agents_amount' }
          ];
        } else {
          this.initColumn();
        }

        this.startDate = res.range.initialDate;
        this.endDate = res.range.endDate;
        this.getData();
      }
    );
  }

  initColumn() {
    this.displayedColumns = ['filas', 'leads', 'corretores_total', 'corretores_online', 'corretores_offline'];
    this.columns = [
      { columnDef: 'filas', header: 'Filas', label: 'name' },
      { columnDef: 'leads', header: 'Leads recebidos', label: 'received_lead_amount', sort: true },
      { columnDef: 'corretores_total', header: 'Total de Corretores', label: 'agents_amount' },
      { columnDef: 'corretores_online', header: 'Corretores online', label: 'agents_online_amount' },
      { columnDef: 'corretores_offline', header: 'Corretores offline', label: 'agents_offline_amount' }
    ];
  }

  getData() {
    this.loading = true;
    this.companyId = this.companyId || "";
    this.distributionService.getReportsOverview(this.startDate, this.endDate, this.maxResults, this.page, this.order, this.companyId).subscribe(
      (res: any) => {
        this.total = res.totalElements;
        this.dataSource = new MatTableDataSource<any>(res.content);
        this.loading = false;
      }, () => {
        this.loading = false;
      }
    );
  }

  pageChange(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.maxResults = event.pageSize;

    this.getData();
  }

  sortTable(event: MatSort): void {
    if (!event.direction) {
      return;
    }

    this.order = event.direction.toUpperCase();
    this.getData();
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }
}